import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { ChannelWorksLogoComponent } from "./channelworks-logo.component";

@NgModule({
  declarations: [ChannelWorksLogoComponent],
  imports: [CoreModule],
  exports: [ChannelWorksLogoComponent],
})
export class ChannelWorksLogoModule {}
